export const environment = {
  production: true,
  apiHost: 'https://fh5.wikylyu.xyz/api',
};
